const DEFAULT_PROVIDERS = [
	"egtdigital",
	"pragmaticplay",
	"evo",
	"ezugi",
	"onetouch",
	"slotagrator",
	"playngo",
	"tvbet",
	"softswiss",
	"netent",
	"betsolution",
	"redtiger",
	"betsoft",
	"amatic",
	"amusnet",
	"redrake",
	"blueprint",
	"bgamming",
	"yggdrasil",
	"elk",
	"endorphina",
	"gameart",
	"dlv",
	"habanero",
	"igrosoft",
	"jftw",
	"platipus",
	"playson",
	"quickspin",
	"revolver",
	"spadegaming",
	"spinomnal",
	"thunderkick",
	"tomhorn",
	"triplecherry",
	"truelab",
	"wazdan",
];

const MARS_PROVIDERS = [
	"evoplay",
	"spinomenal",
	"amatic",
	"quickspin",
	"netent",
	"microgaming",
	"ezugi",
	"playngo",
	"betsoft",
	"pragmaticplay",
	"evolution",
	"amusnet",
	"yggdrasil",
	"egtdigital",
	"evo",
	"onetouch",
	"slotagrator",
	"tvbet",
	"softswiss",
	"betsolution",
	"redtiger",
	"redrake",
	"blueprint",
	"bgamming",
	"elk",
	"endorphina",
	"gameart",
	"dlv",
	"habanero",
	"igrosoft",
	"jftw",
	"platipus",
	"playson",
	"revolver",
	"spadegaming",
	"spinomnal",
	"thunderkick",
	"tomhorn",
	"triplecherry",
	"truelab",
	"wazdan",
];

export const getProviders = () => {
	if (window.TENANT.includes("mars") || window.MARS_PROVIDERS) {
		return MARS_PROVIDERS;
	}

	return DEFAULT_PROVIDERS;
};
